import { AsyncStatus } from '@ts/async-state';
import { Subscription } from '../../models';

export interface CurrentSubscriptionState {
  subscription: Subscription;
  loadStatus: AsyncStatus;
  error: unknown;
}

export const CURRENT_SUBSCRIPTION_FEATURE_KEY = 'current';

export const initialCurrentSubscriptionState: CurrentSubscriptionState = {
  loadStatus: 'loading',
  subscription: null,
  error: null,
};
